// This file contains all your dispatch types
export const EXAMPLE = "EXAMPLE";
export const TOGGLETHEME = "TOGGLETHEME";
export const TOGGLESIDEBAROPEN = "TOGGLESIDEBAROPEN";
export const SETUSER = "SETUSER";
export const TOGGLEAPPLOADING = "TOGGLEAPPLOADING";
export const SETPAYMENTMODAL = "SETPAYMENTMODAL";
export const SETWELCOMEVIDEOMODAL = "SETWELCOMEVIDEOMODAL";
